import type {
	AuthRepository,
	EmailOtpRepository,
	PasskeyRepository,
	TotpRepository
} from '@contexts/auth/domain';
import {
	inMemoryAuthRepositoryBuilder,
	restApiAuthRepositoryBuilder
} from '@contexts/auth/infrastructure';
import { inMemoryEmailOtpRepositoryBuilder } from '@contexts/auth/infrastructure/in-memory/in-memory-email-otp.respository';
import { inMemoryPasskeyRepositoryBuilder } from '@contexts/auth/infrastructure/in-memory/in-memory-passkey.repository';
import { inMemoryTotpRepositoryBuilder } from '@contexts/auth/infrastructure/in-memory/in-memory-totp.respository';
import { restApiEmailOtpRepositoryBuilder } from '@contexts/auth/infrastructure/rest-api/rest-api-email-otp.repository';
import { restApiPasskeyRepositoryBuilder } from '@contexts/auth/infrastructure/rest-api/rest-api-passkey.repository';
import { restApiTotpRepositoryBuilder } from '@contexts/auth/infrastructure/rest-api/rest-api-totp.repository';
import {
	type EnvironmentRepository,
	type HttpService,
	type RepositoryConfiguration,
	RepositoryType
} from '@contexts/shared/domain';

import { ENVIRONMENT_REPOSITORY } from '@dependencies/shared';
import { HTTP_SERVICE } from '@dependencies/shared/domain/contracts';

export const AUTH_REPOSITORY_DEFINITION: RepositoryConfiguration<AuthRepository> = {
	[RepositoryType.IN_MEMORY]: {
		factory: () => inMemoryAuthRepositoryBuilder(),
		deps: []
	},
	[RepositoryType.REST_API]: {
		factory: (env: EnvironmentRepository, http: HttpService) =>
			restApiAuthRepositoryBuilder(env, http),
		deps: [ENVIRONMENT_REPOSITORY, HTTP_SERVICE]
	}
};

export const TOTP_REPOSITORY_DEFINITION: RepositoryConfiguration<TotpRepository> = {
	[RepositoryType.IN_MEMORY]: {
		factory: () => inMemoryTotpRepositoryBuilder(),
		deps: []
	},
	[RepositoryType.REST_API]: {
		factory: (env: EnvironmentRepository, http: HttpService) =>
			restApiTotpRepositoryBuilder(env, http),
		deps: [ENVIRONMENT_REPOSITORY, HTTP_SERVICE]
	}
};

export const EMAIL_OTP_REPOSITORY_DEFINITION: RepositoryConfiguration<EmailOtpRepository> = {
	[RepositoryType.IN_MEMORY]: {
		factory: () => inMemoryEmailOtpRepositoryBuilder(),
		deps: []
	},
	[RepositoryType.REST_API]: {
		factory: (env: EnvironmentRepository, http: HttpService) =>
			restApiEmailOtpRepositoryBuilder(env, http),
		deps: [ENVIRONMENT_REPOSITORY, HTTP_SERVICE]
	}
};

export const PASSKEY_REPOSITORY_DEFINITION: RepositoryConfiguration<PasskeyRepository> = {
	[RepositoryType.IN_MEMORY]: {
		factory: () => inMemoryPasskeyRepositoryBuilder(),
		deps: []
	},
	[RepositoryType.REST_API]: {
		factory: (env: EnvironmentRepository, http: HttpService) =>
			restApiPasskeyRepositoryBuilder(env, http),
		deps: [ENVIRONMENT_REPOSITORY, HTTP_SERVICE]
	}
};
